import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authApi } from '../hooks/useApi';
import { C } from '../components/UI';
import { LanguageSelector } from '../components/LanguageSelector';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [form, setForm]   = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    const pwdRegex = /(?=.*[A-Z])(?=.*[0-9]).{10,}/;
    if (!pwdRegex.test(form.password)) { setError(t('auth.passwordStrong')); return; }
    setError(''); setLoading(true);
    try {
      const { token, user } = await authApi.register(form);
      localStorage.setItem('ebios_token', token); localStorage.setItem('ebios_user', JSON.stringify(user)); navigate('/');
    } catch (err) { setError(err.response?.data?.error || t('auth.errorRegister')); }
    finally { setLoading(false); }
  }

  return (
    <div style={S.page}>
      <div style={S.topRight}><LanguageSelector /></div>
      <div style={S.card}>
        <div style={S.logo}><div style={S.logoTitle}>{t('app.name')}</div><div style={S.logoSub}>{t('app.tagline')}</div></div>
        <h1 style={S.title}>{t('auth.register')}</h1>
        <form onSubmit={handleSubmit}>
          <div style={S.group}><label style={S.label}>{t('auth.name')}</label><input style={S.input} required autoFocus value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></div>
          <div style={S.group}><label style={S.label}>{t('auth.email')}</label><input style={S.input} type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
          <div style={S.group}><label style={S.label}>{t('auth.passwordHint')}</label><input style={S.input} type="password" required value={form.password} onChange={e => setForm({...form, password: e.target.value})} /></div>
          {error && <div style={S.error}>{error}</div>}
          <button type="submit" style={S.btn} disabled={loading}>{loading ? t('auth.creating') : t('auth.createAccount')}</button>
        </form>
        <p style={S.foot}>{t('auth.hasAccount')} <Link to="/login" style={{ color: C.accent }}>{t('auth.login')}</Link></p>
      </div>
    </div>
  );
}

const S = {
  page:  { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, fontFamily:"'Segoe UI',system-ui,sans-serif", position:'relative' },
  topRight: { position:'absolute', top:20, right:20 },
  card:  { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:20, padding:'48px 40px', maxWidth:420, width:'100%' },
  logo:  { textAlign:'center', marginBottom:32 },
  logoTitle: { fontFamily:'Geist,system-ui,sans-serif', fontSize:28, color:'var(--text)', letterSpacing:-1 },
  logoSub: { fontSize:10, color:'var(--text3)', textTransform:'uppercase', letterSpacing:3, marginTop:4 },
  title: { fontSize:22, color:'var(--text)', marginBottom:24, fontWeight:600 },
  group: { marginBottom:16 },
  label: { display:'block', fontSize:11, color:'var(--text2)', textTransform:'uppercase', letterSpacing:.8, marginBottom:6, fontWeight:600 },
  input: { width:'100%', background:'var(--input-bg)', border:'1px solid var(--border)', color:'var(--text)', padding:'11px 14px', borderRadius:8, fontSize:14, outline:'none', boxSizing:'border-box', fontFamily:'inherit' },
  error: { background:'rgba(255,79,110,.1)', border:'1px solid rgba(255,79,110,.2)', color:'var(--red)', padding:'10px 14px', borderRadius:8, fontSize:13, marginBottom:16 },
  btn:   { width:'100%', background:'var(--blue)', color:'white', border:'none', padding:12, borderRadius:8, fontSize:15, fontWeight:600, cursor:'pointer', marginTop:8, fontFamily:'inherit' },
  foot:  { textAlign:'center', fontSize:13, color:'var(--text3)', marginTop:24 },
};
